<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        News Details
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>News Details</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <section *ngIf="currentIndDetail">
        <div class="blog-details-wrapper cpy-5">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-8 mb-5 mb-lg-0">
                        <div class="blog-details">
                            <div class="blog-img mt-0"><img [src]="currentIndDetail?.image" class="img-fluid blog-detail-image">
                            </div>
                            <ul class="post-date-time">
                                <li>
                                    <p class="font-20"><i class="icofont-ui-calendar"></i> {{currentIndDetail?.publishDate}}</p>
                                </li>
                            </ul>

                            <h2 class="l-post-title1 mb-3">{{currentIndDetail?.title}}</h2>

                            <div class="post-des">
                                <p class="service-des mb-3">{{currentIndDetail?.description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>